<micro-lookup domain="smppserver" obj="smppServers" url="/smppserver/smppServers" [key]="smppServerId"></micro-lookup>
